var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _circle, _g, _circle2, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddressEmptyIcon = function SvgAddressEmptyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#AddressEmptyIcon_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F1F2",
    d: "M110.184 73.992c1.744 1.754 3.439 3.578 5.261 5.254 1.182 1.092 1.201 1.814 0 2.964-7.732 7.41-16.53 13.162-26.567 16.789-25.627 9.271-49.994 6.493-72.889-8.317-3.798-2.456-7.092-5.713-10.629-8.57-1.114-.906-1.153-1.627-.077-2.67 3.73-3.657 7.392-7.38 11.045-11.115.97-.975 1.638-1.102 2.723-.068 7.848 7.41 16.975 12.538 27.497 14.838 20.191 4.427 38.26-.087 53.986-13.668 2.732-2.36 2.693-2.398 5.222.127L110.174 74z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "AddressEmptyIcon_svg__b",
    width: 208,
    height: 113,
    x: -48,
    y: -8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F1F2",
    d: "M60.612 104.616c-25.071 0-43.705-12.196-48.787-16.94l-59.524-50.185L60.61-8 159.5 32l-48.746 54.999c-16.601 14.229-40.316 17.617-50.142 17.617"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#AddressEmptyIcon_svg__b)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M61.57 84.857v22.5l25.715-2.571L80.856 81z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "m80.856 81 6.428 23.786L116.213 108 99.498 85.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M6.285 108 23 84.214 42.928 81l-7.714 23.786z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "m42.93 81-7.715 23.786 26.357 2.571v-22.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEE2E9",
    d: "M61.594 78.971v29l27.619-3.314L82.308 74z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFD3DB",
    d: "m82.313 74 6.904 30.657 31.072 4.143-17.953-29z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEE2E9",
    d: "m2.215 108.8 17.952-30.657L41.572 74l-8.286 30.657z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFD3DB",
    d: "m41.575 74-8.286 30.657 28.31 3.314v-29z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64,
    cy: 84,
    fill: "#CDD2DC",
    opacity: 0.7,
    rx: 16,
    ry: 3,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E3EC",
    d: "M62.977 20.435c-12.955 0-23.477 9.932-23.477 22.22 0 4.695 1.55 9.057 4.178 12.649.131.208.24.41.399.59l15.993 19.05c.797.995 1.855 1.476 2.913 1.476s2.105-.476 2.907-1.477L81.88 55.89c.147-.187.267-.384.381-.569 2.64-3.597 4.195-7.953 4.195-12.665-.011-12.288-10.517-22.22-23.478-22.22m0 31.109c-5.187 0-9.393-3.986-9.393-8.889 0-4.909 4.206-8.888 9.393-8.888 5.182 0 9.393 3.985 9.393 8.888-.005 4.903-4.211 8.889-9.393 8.889"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38,
    cy: 86.8,
    fill: "#CDD2DC",
    opacity: 0.7,
    rx: 3.5,
    ry: 1,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#6D9AE8",
    d: "M38 71.8c-3.035 0-5.5 2.306-5.5 5.16 0 1.09.363 2.103.979 2.937.03.048.056.095.093.137l3.747 4.423A.87.87 0 0 0 38 84.8c.248 0 .494-.11.681-.343l3.746-4.424q.05-.067.09-.133a4.9 4.9 0 0 0 .982-2.94c-.003-2.854-2.464-5.16-5.5-5.16m0 7.224c-1.215 0-2.2-.926-2.2-2.064 0-1.14.985-2.064 2.2-2.064 1.214 0 2.2.925 2.2 2.064 0 1.138-.986 2.064-2.2 2.064"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "AddressEmptyIcon_svg__c",
    width: 74,
    height: 74,
    x: 60,
    y: -14,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 23.499,
    r: 36.5,
    fill: "#BDC5D1",
    opacity: 0.7
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#AddressEmptyIcon_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BDC5D1",
    d: "M62.977 20.434c-12.955 0-23.477 9.932-23.477 22.22 0 4.696 1.55 9.058 4.178 12.65.131.207.24.41.399.59L60.07 74.942c.797.996 1.855 1.476 2.913 1.476s2.105-.475 2.907-1.476L81.88 55.888c.147-.186.267-.383.381-.568 2.64-3.597 4.195-7.954 4.195-12.666-.011-12.288-10.517-22.22-23.478-22.22m0 31.11c-5.187 0-9.393-3.986-9.393-8.89 0-4.908 4.206-8.887 9.393-8.887 5.182 0 9.393 3.985 9.393 8.888-.005 4.903-4.211 8.888-9.393 8.888"
  })))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3,
    cy: 10.3,
    r: 12.3,
    fill: "#F45149",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    transform: "matrix(-1 0 0 1 101.602 12.8)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M91.413 19.503a1.57 1.57 0 0 1-1.151-.478 1.57 1.57 0 0 1-.478-1.151q0-.674.478-1.134a1.57 1.57 0 0 1 1.15-.478q.674 0 1.134.478.478.46.478 1.134 0 .672-.478 1.15a1.51 1.51 0 0 1-1.133.479m-1.328 11.333v-9.934h2.85v9.934z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231815",
    strokeMiterlimit: 10,
    strokeWidth: 0.513,
    d: "M41.65 67.831s-8.766-17-17.18-17.038c-8.414-.04-1.003 11.51 4.522 7.394S28.59 40.545 20.65 37.8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.52,
    d: "m103 51.8-16 16"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "AddressEmptyIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v120H0z"
  })))));
};
export default SvgAddressEmptyIcon;